module.exports = __webpack_public_path__ + "images/image_menu_426ebdde3cfd18245eb9883324482d88.svg";